/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  "iframe-page": () => import("@/views/_builtin/iframe-page/[url].vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  "ecommerce_aigc-prompt-template": () => import("@/views/ecommerce/aigc-prompt-template/index.vue"),
  "ecommerce_conversation-chat": () => import("@/views/ecommerce/conversation-chat/[id].vue"),
  ecommerce_conversation: () => import("@/views/ecommerce/conversation/index.vue"),
  ecommerce_order: () => import("@/views/ecommerce/order/index.vue"),
  ecommerce_payment: () => import("@/views/ecommerce/payment/index.vue"),
  "ecommerce_player-detail": () => import("@/views/ecommerce/player-detail/[id].vue"),
  ecommerce_player: () => import("@/views/ecommerce/player/index.vue"),
  ecommerce_points: () => import("@/views/ecommerce/points/index.vue"),
  ecommerce_product: () => import("@/views/ecommerce/product/index.vue"),
  "ecommerce_video-pool": () => import("@/views/ecommerce/video-pool/index.vue"),
  "ecommerce_video-scene-config": () => import("@/views/ecommerce/video-scene-config/index.vue"),
  "ecommerce_virtual-partner": () => import("@/views/ecommerce/virtual-partner/index.vue"),
  home: () => import("@/views/home/index.vue"),
  "manage_aigc-config": () => import("@/views/manage/aigc-config/index.vue"),
  "manage_cache-list": () => import("@/views/manage/cache-list/index.vue"),
  "manage_cache-monitor": () => import("@/views/manage/cache-monitor/index.vue"),
  manage_config: () => import("@/views/manage/config/index.vue"),
  manage_dept: () => import("@/views/manage/dept/index.vue"),
  manage_dict: () => import("@/views/manage/dict/index.vue"),
  "manage_email-config": () => import("@/views/manage/email-config/index.vue"),
  "manage_file-manage": () => import("@/views/manage/file-manage/index.vue"),
  "manage_job-log": () => import("@/views/manage/job-log/index.vue"),
  manage_job: () => import("@/views/manage/job/index.vue"),
  "manage_login-log": () => import("@/views/manage/login-log/index.vue"),
  manage_menu: () => import("@/views/manage/menu/index.vue"),
  "manage_operation-log": () => import("@/views/manage/operation-log/index.vue"),
  "manage_oss-config": () => import("@/views/manage/oss-config/index.vue"),
  manage_post: () => import("@/views/manage/post/index.vue"),
  manage_role: () => import("@/views/manage/role/index.vue"),
  "manage_system-monitor": () => import("@/views/manage/system-monitor/index.vue"),
  "manage_user-detail": () => import("@/views/manage/user-detail/[id].vue"),
  manage_user: () => import("@/views/manage/user/index.vue"),
  payment_config: () => import("@/views/payment/config/index.vue"),
  "payment_webhook-log": () => import("@/views/payment/webhook-log/index.vue"),
  "user-center": () => import("@/views/user-center/index.vue"),
};
